import type groupResponsibleUseCases from '@/scopes/account/group-responsible/domain/useCases'
import * as React from 'react'
import groupResponsibleAPIClient from '@/scopes/account/group-responsible/infrastructure/groupResponsibleAPIClient'
import { groupResponsibleStore } from '../infrastructure/store'

interface GroupResponsibleDependencies {
  groupResponsibleAPIClient: typeof groupResponsibleAPIClient
  groupResponsibleStore: typeof groupResponsibleStore
  useCases?: ReturnType<typeof groupResponsibleUseCases>

}

const defaultDependencies: GroupResponsibleDependencies = {
  groupResponsibleAPIClient,
  groupResponsibleStore,
}

const GroupResponsibleDependenciesContext = React.createContext<GroupResponsibleDependencies>(defaultDependencies)

export function GroupResponsibleDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: GroupResponsibleDependencies }>) {
  return (
    <GroupResponsibleDependenciesContext value={dependencies}>
      {children}
    </GroupResponsibleDependenciesContext>
  )
}

export function useGroupResponsibleDependencies() {
  return React.use(GroupResponsibleDependenciesContext)
}

export function useGroupResponsibleUseCases() {
  const { useCases } = useGroupResponsibleDependencies()
  if (!useCases) {
    throw new Error('useCases not provided')
  }
  return useCases
}
